if (!customElements.get('curated-product-cards')) {
  customElements.define('curated-product-cards', class CuratedProductCards extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-curated-scroller]');
      this.previous = this.querySelector('[data-curated-previous]');
      this.next = this.querySelector('[data-curated-next]');
      this.progress = this.querySelector('[data-curated-progress]');
      if (!this.scroller) return;
      this.update = this.update.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onPreviousClick = () => this.move(-1);
      this.onNextClick = () => this.move(1);
      this.previous?.addEventListener('click', this.onPreviousClick);
      this.next?.addEventListener('click', this.onNextClick);
      this.scroller.addEventListener('scroll', this.update, { passive: true });
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      if (window.ResizeObserver) {
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.scroller);
      } else {
        window.addEventListener('resize', this.update, { passive: true });
      }
      this.update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.previous?.removeEventListener('click', this.onPreviousClick);
      this.next?.removeEventListener('click', this.onNextClick);
      this.scroller?.removeEventListener('scroll', this.update);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
      window.removeEventListener('resize', this.update);
    }

    move(direction) {
      this.scroller.scrollBy({
        left: direction * this.scroller.clientWidth * .82,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    onBlockSelect(event) {
      event.target?.scrollIntoView({
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }

    update() {
      const max = this.scroller.scrollWidth - this.scroller.clientWidth;
      const position = Math.max(0, this.scroller.scrollLeft);
      if (this.previous) this.previous.disabled = position <= 2;
      if (this.next) this.next.disabled = max <= 2 || position >= max - 2;
      if (this.progress) this.progress.style.setProperty('--progress', `${max > 0 ? Math.min(100, ((position + this.scroller.clientWidth) / this.scroller.scrollWidth) * 100) : 100}%`);
    }
  });
}
